import capitalize from 'lodash-es/capitalize';

import type { StoreCategory } from '@jane/business-admin/data-access';
import { encodeKey } from '@jane/shared-b2b/components';
import type {
  ConditionOption,
  SelectConditionSection,
} from '@jane/shared-b2b/components';

/**
 * Placeholder the API sends for products whose kind has no subcategory. It is
 * only worth showing when it groups brand subtypes underneath it.
 */
const UNSET_SUBTYPE = '(Subcategory not set)';

/**
 * Options are matched by value alone, so every level carries its ancestors'
 * path — a bare "Pre-roll" would collide across kinds.
 */
const toOption = (label: string, segments: string[]): ConditionOption => ({
  label,
  value: encodeKey(segments),
});

const toSubtypeOptions = (category: StoreCategory): ConditionOption[] =>
  category.subtypes
    .filter(
      (subtype) =>
        subtype.subtype &&
        (subtype.subtype !== UNSET_SUBTYPE || subtype.brand_subtypes.length > 0)
    )
    .map((subtype) => ({
      ...toOption(subtype.subtype, [category.kind, subtype.subtype]),
      subItems: subtype.brand_subtypes.map((brandSubtype) =>
        toOption(brandSubtype, [category.kind, subtype.subtype, brandSubtype])
      ),
    }));

/** The categories endpoint's kind/subtype/brand-subtype tree as one condition section */
export const toCategorySection = (
  categories: StoreCategory[] = []
): SelectConditionSection => ({
  allowExcludes: true,
  items: categories.map((category) => ({
    ...toOption(capitalize(category.kind), [category.kind]),
    subItems: toSubtypeOptions(category),
  })),
  key: 'kinds',
  label: 'Categories',
  nested: true,
  type: 'multiselect',
});
